import { Injectable } from '@angular/core';
import { combineLatest, filter, Subject, take } from 'rxjs';

import { OnboardingDialogComponent } from '../components/onboarding-dialog/onboarding-dialog.component';
import { OnboardingStoreService } from '../store/services/onboarding-store.service';
import { RpcDialogService } from '@core-services/dialog/rpc-dialog.service';

@Injectable({ providedIn: 'root' })
export class OnboardingDialogPopupService {
    private readonly unsubscribe$ = new Subject<void>();

    constructor(
        private readonly rpcDialogService: RpcDialogService,
        private readonly onboardingStoreService: OnboardingStoreService,
    ) { }

    public openDialog(): void {
        this.onboardingStoreService.loadOnboardingData();

        combineLatest([
            this.onboardingStoreService.itemToDisplay$,
            this.onboardingStoreService.isLoading$
        ]).pipe(
            filter(([, loading]) => !loading),
            take(1),
        ).subscribe(([item, loading]) => {
            if (item != null && !loading) {
                this.rpcDialogService.openDialog(OnboardingDialogComponent, null, { customClass: 'rpc-onboarding-modal' });
            }
            else {
                this.onboardingStoreService.resetState();
            }
        });
    }
}